import { isNative } from '@whelk/const/src/env';

export enum PlatformType {
  WEB = 'web',
  NATIVE = 'native',
  UNKNOWN = 'unknown',
}

export const currentPlatform = isNative ? PlatformType.NATIVE : PlatformType.WEB;
